import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.css'],
    standalone: false
})
export class PageNotFoundComponent implements OnInit {

  constructor() { }

  //Empty page that is displayed when a url endpoint is not registered in the router. See app-routing,module.ts
  ngOnInit(): void {
  }

}
